import type { AssetAssignment } from "../domain";
import type { AssetAssignmentDto } from "./assetAssignmentDtos";

export function assetAssignmentFromDto(dto: AssetAssignmentDto): AssetAssignment {
  return {
    id: dto.id,
    branch: {
      id: dto.branch.id,
      nameEn: dto.branch.nameEn,
      nameAr: dto.branch.nameAr,
    },
    asset: {
      id: dto.asset.id,
      code: dto.asset.code,
      nameEn: dto.asset.nameEn,
      nameAr: dto.asset.nameAr,
    },
    // The assignment's creation date is when the asset joined the branch.
    assignedAt: dto.createdAt,
  };
}
